import React from 'react';
import { RealizedGainLossDetails } from '../../../../tabs/GainLoss/Components/RealizedGainLossTab/components/RealizedGainLossDetails/RealizedGainLossDetails';

interface Props {
  title: string;
}

export const RealizedGainLossDetailCard = ({ title }: Props) => {
  return <RealizedGainLossDetails title={title} />;
};
